import http from '../../utils/httpClient'

class currencyService {
  getCurrencyRate = async () => {
    return await http.get('/api/Currency/Get')
  }
}

export default new currencyService()
